import React, { useEffect } from 'react';
import { Table } from 'antd';
import { config } from './config';
import { useAppApi } from 'hooks/useApi';

function OrderStatus(props) {
  const { budget } = props;
  const { payload: resItems, refresh: refreshItems } = useAppApi({
    url: `order/items?id=${budget.idBudget}`,
    defaultValue: {},
  });

  useEffect(() => {
    refreshItems();
  }, [budget.idBudget, refreshItems]);

  const { items } = resItems;

  const columns = config.tableColumns();

  return <Table columns={columns} dataSource={items} rowKey="id" />;
}


export default OrderStatus;
